module.exports = __webpack_public_path__ + "static/media/southwestern.8159fda6.png";